import { render, staticRenderFns } from "./Chose.vue?vue&type=template&id=0641f32e&scoped=true&"
import script from "./Chose.vue?vue&type=script&lang=js&"
export * from "./Chose.vue?vue&type=script&lang=js&"
import style0 from "./Chose.vue?vue&type=style&index=0&id=0641f32e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0641f32e",
  null
  
)

export default component.exports